import { render, staticRenderFns } from "./ShowJoiningInternationalNGO.vue?vue&type=template&id=6923eff8&"
import script from "./ShowJoiningInternationalNGO.vue?vue&type=script&lang=js&"
export * from "./ShowJoiningInternationalNGO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports